// TCW Update ATC Button for ring size
$( document ).ready(function() {
  $( "#5a69b3b0-6970-432f-93b9-b39e6f290bb6" ).on( "change", function() {
    var selectedSize = $('#5a69b3b0-6970-432f-93b9-b39e6f290bb6').find(":selected").val();
    
    if(selectedSize > 5.4 && selectedSize < 7.1) {
      $('.add-to-cart .atc-text').html('Add to cart');
      $('.main-product__block-custom_text').hide();
    } else {
      $('.add-to-cart .atc-text').html('Pre-Order');
      $('.main-product__block-custom_text').show();
    }
  });
});